/* Zingleberry Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  // ── Scroll Reveal ──
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('visible'));
  }

  // ── Mobile Nav Toggle ──
const toggleBtn = document.getElementById('nav-toggle');
const mobileNav = document.getElementById('mobile-nav');
if (toggleBtn && mobileNav) {
  toggleBtn.addEventListener('click', function () {
    mobileNav.classList.toggle('open');
    toggleBtn.textContent = mobileNav.classList.contains('open') ? '✕' : '☰';
  });
}

// ── Mobile Nav Accordion (sub-menus) ──
document.querySelectorAll('.mobile-nav-parent').forEach(function(btn) {
  btn.addEventListener('click', function() {
    const sub = this.nextElementSibling;
    const isOpen = sub.classList.contains('open');

    // Close all other open sub-menus
    document.querySelectorAll('.mobile-nav-sub.open').forEach(function(el) {
      el.classList.remove('open');
      el.previousElementSibling.setAttribute('aria-expanded', 'false');
      el.previousElementSibling.querySelector('.mobile-nav-arrow').style.transform = '';
    });

    // Toggle this one
    if (!isOpen) {
      sub.classList.add('open');
      this.setAttribute('aria-expanded', 'true');
      this.querySelector('.mobile-nav-arrow').style.transform = 'rotate(90deg)';
    }
  });
});

  // ── Sticky header shadow ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        header.style.boxShadow = '0 4px 30px rgba(0,0,0,0.5)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

});

